import { render, staticRenderFns } from "./agentList.vue?vue&type=template&id=129712cf"
import script from "./agentList.vue?vue&type=script&lang=js"
export * from "./agentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports